module.exports = __webpack_public_path__ + "img/wing-right-peak.e8a1162d.svg";